module.exports = __webpack_public_path__ + "static/media/flag-gl.fceb695b.webp";